<template>
  <div class="main">
    <c-panel title="Mapa de Instituições" titleIcon="fas fa-map-marked-alt">

      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="24" :sm="24" :md="24">
          <div class="field-label">Instituição</div>
          <el-select
            v-model="instituicaoSelecionadaId"
            filterable
            clearable
            placeholder="Selecione uma instituição"
            style="width: 100%;"
            :loading="loadingInstituicoes"
            :disabled="loadingInstituicoes"
            @change="onChangeInstituicao"
          >
            <el-option
              v-for="inst in instituicoes"
              :key="inst.id"
              :label="inst.nome"
              :value="inst.id"
            />
          </el-select>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" class="u-mt-10-mobile">
          <div class="inst-meta" v-if="instituicaoSelecionada">
            <div class="inst-meta__title">{{ instituicaoSelecionada.nome }}</div>
            <div class="inst-meta__subtitle">
              {{ instituicaoSelecionada.endereco }}
            </div>
          </div>
          <el-alert
            v-else-if="erroInstituicoes"
            type="error"
            :closable="false"
            :title="erroInstituicoes"
          />
          <el-alert
            v-else
            type="info"
            :closable="false"
            title="Selecione uma instituição para visualizar no mapa."
          />
        </el-col>
      </el-row>

      <el-alert
        v-if="!hasGoogleMapsKey"
        type="warning"
        :closable="false"
        title="Google Maps não configurado"
        description="Defina a variável de ambiente VUE_APP_GOOGLE_MAPS_KEY para carregar o mapa."
        class="u-mb-10"
      />

      <div class="map-wrapper">
        <div v-if="!hasGoogleMapsKey" class="map-placeholder">
          <div class="map-placeholder__title">Mapa indisponível</div>
          <div class="map-placeholder__subtitle">
            Configure a variável <b>VUE_APP_GOOGLE_MAPS_KEY</b> para carregar o Google Maps.
          </div>
        </div>
        <GmapMap
          v-else
          ref="mapRef"
          :center="mapCenter"
          :zoom="mapZoom"
          :options="mapOptions"
          class="map"
        >
          <GmapMarker
            v-if="instituicaoSelecionada"
            :position="markerPosition"
            :clickable="true"
            :draggable="false"
            @click="infoWindowOpened = true"
          />

          <GmapInfoWindow
            v-if="instituicaoSelecionada"
            :position="markerPosition"
            :opened="infoWindowOpened"
            @closeclick="infoWindowOpened = false"
          >
            <div style="min-width: 200px;">
              <div style="font-weight: 600;">{{ instituicaoSelecionada.nome }}</div>
              <div style="font-size: 12px; margin-top: 4px;">{{ instituicaoSelecionada.endereco }}</div>
            </div>
          </GmapInfoWindow>
        </GmapMap>
      </div>

    </c-panel>
  </div>
</template>
<script>

export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    instituicoes: [],
    instituicaoSelecionadaId: null,
    mapCenter: { lat: -11.548329, lng: -41.157557 },
    mapZoom: 14,
    markerPosition: { lat: -11.548329, lng: -41.157557 },
    infoWindowOpened: false,
    loadingInstituicoes: false,
    erroInstituicoes: '',
    mapOptions: {
      mapTypeId: 'roadmap',
      streetViewControl: false,
      fullscreenControl: true,
      mapTypeControl: true
    }
  }),
  computed: {
    hasGoogleMapsKey () {
      return !!(process && process.env && process.env.VUE_APP_GOOGLE_MAPS_KEY)
    },
    instituicaoSelecionada () {
      return this.instituicoes.find(i => i.id === this.instituicaoSelecionadaId) || null
    }
  },
  mounted () {
    this.loadInstituicoes()
  },
  methods: {
    onChangeInstituicao () {
      this.applyInstituicaoToMap()
    },
    async loadInstituicoes () {
      this.loadingInstituicoes = true
      this.erroInstituicoes = ''

      const baseUrlApi = (this.$store && this.$store.state && this.$store.state.config && this.$store.state.config.baseUrlApi)
        ? String(this.$store.state.config.baseUrlApi).replace(/\/$/, '')
        : ''
      const url = baseUrlApi
        ? `${baseUrlApi}/api/instituicao/getDataForMaps`
        : 'http://www.edugestao.com.br/api/instituicao/getDataForMaps'

      try {
        const resp = await this.$axios.get(url, this.$store.getters.getHeaderAuth)
        const list = Array.isArray(resp.data) ? resp.data : []

        // garante tipos numéricos e remove registros sem coordenadas válidas
        this.instituicoes = list
          .map(i => ({
            id: i.id,
            nome: i.nome,
            endereco: i.endereco,
            lat: typeof i.lat === 'number' ? i.lat : parseFloat(i.lat),
            lng: typeof i.lng === 'number' ? i.lng : parseFloat(i.lng)
          }))
          .filter(i => Number.isFinite(i.lat) && Number.isFinite(i.lng))

        if (this.instituicoes.length) {
          this.instituicaoSelecionadaId = this.instituicoes[0].id
          this.applyInstituicaoToMap()
        } else {
          this.instituicaoSelecionadaId = null
        }
      } catch (e) {
        this.instituicoes = []
        this.instituicaoSelecionadaId = null
        this.erroInstituicoes = 'Não foi possível carregar as instituições para o mapa.'
      } finally {
        this.loadingInstituicoes = false
      }
    },
    async applyInstituicaoToMap () {
      this.infoWindowOpened = false
      if (!this.instituicaoSelecionada) return

      const { lat, lng } = this.instituicaoSelecionada
      this.mapCenter = { lat, lng }
      this.markerPosition = { lat, lng }
      this.mapZoom = 15

      // Se o mapa já estiver montado, faz pan/zoom suave
      try {
        const map = await this.$refs.mapRef.$mapPromise
        map.panTo(this.mapCenter)
        map.setZoom(this.mapZoom)
      } catch (e) {
        // ignore (ex: mapa ainda não inicializou)
      }
    }
  }
}
</script>

<style scoped>
.field-label {
  font-size: 12px;
  color: #6d6d6d;
  margin-bottom: 4px;
}

.inst-meta {
  padding-top: 18px;
}
.inst-meta__title {
  font-weight: 600;
}
.inst-meta__subtitle {
  font-size: 12px;
  color: #6d6d6d;
  margin-top: 2px;
}

.map-wrapper {
  height: calc(100vh - 320px);
  min-height: 420px;
  width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #f7f7f7;
}

.map-placeholder {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px;
  text-align: center;
}
.map-placeholder__title {
  font-weight: 600;
}
.map-placeholder__subtitle {
  font-size: 12px;
  color: #6d6d6d;
  margin-top: 6px;
}

.map {
  width: 100%;
  height: 100%;
}

/* helper for small screens */
.u-mt-10-mobile {
  margin-top: 10px;
}
</style>
